.<template>
    <div>
        <p class="block small mt-6 mb-2">Hub Type:</p> 
        <div class="h-11 flex bg-gray-100 items-center px-4">
        <p class="small m-0">
            {{ customHubType }}
        </p>
        </div>
    </div>
</template>

<script setup>

defineProps({
    customHubType: {
        type: String,
        required: true,
    }
});

</script>